import { z } from "zod";
//#region src/app-factory-ca.schemas.ts
/**
* Zod schema for the app-factory-CA pull surface (device-mtls WS-B6, R3=Q).
*
* release-engine (CP) PULLS the verified CA cert from core-api's
* `GET /internal/v1/ca/:appId/cert` over `CpMtlsGuard` (CN=cp-platform). The CA
* cert is PUBLIC (a trust anchor); the private key stays in KMS.
*
* Convention (mirrors `operator-cert.schemas.ts`): `.strict()`.
*/
/** Response of core-api `GET /internal/v1/ca/:appId/cert` (release-engine pulls this over CpMtls). */
const VerifiedCaCertResponseSchema = z.object({
	appId: z.string().uuid(),
	orgId: z.string().uuid(),
	caCertPem: z.string().min(1).max(16384).regex(/-----BEGIN CERTIFICATE-----/),
	fingerprint: z.string().regex(/^[0-9a-f]{64}$/)
}).strict();
//#endregion
export { VerifiedCaCertResponseSchema };

//# sourceMappingURL=app-factory-ca.schemas.js.map